import { render, staticRenderFns } from "./NavigationQuota.vue?vue&type=template&id=2fa51c2a&scoped=true"
import script from "./NavigationQuota.vue?vue&type=script&lang=js"
export * from "./NavigationQuota.vue?vue&type=script&lang=js"
import style0 from "./NavigationQuota.vue?vue&type=style&index=0&id=2fa51c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa51c2a",
  null
  
)

export default component.exports